export const environment = {
  production: true,
  occ: {
    prefix: '/rest/v2/',
  }
};
